import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
interface CTAButtonProps {
  label: string;
  id?: string;
  showSubtext?: boolean;
  dark?: boolean;
}
export function CTAButton({
  label,
  id,
  showSubtext = false,
  dark = false
}: CTAButtonProps) {
  return <div id={id} className="mx-auto w-full max-w-xl text-center" data-id="element-11" data-mp="2fzbqq8yyj20o">
      <a href={CHECKOUT_URL} className="group flex w-full items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-5 text-center text-[17px] font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_10px_30px_-8px_rgba(22,163,74,0.6)] transition-[transform,background-color] duration-150 ease-out hover:bg-cta-dark active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 sm:text-lg" data-id="element-12" data-mp="2tzcrzpj4wbgo">
        <span data-id="element-13" data-mp="3cqdp080p1wxl">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-14" data-mp="3cnhrulwo7ca7" />
      </a>
      {showSubtext && <p className={`mt-3 text-sm leading-relaxed ${dark ? 'text-brand-light' : 'text-muted'}`} data-id="element-15" data-mp="19apraooau2cl">
          Instant digital access · One-time payment of <strong className={dark ? 'text-white' : 'text-ink'} data-id="element-16" data-mp="1i9urdzfie3qv">USD $27</strong> · Lifetime access · 7-Day Guarantee
        </p>}
    </div>;
}